import React from "react";
import { Navigate } from "react-router-dom";
import { getSessionItem } from 'utils/storage';

const PrivateRoute = ({ children }) => {
    const sessionUser = getSessionItem('loginUser'); // 세션 값 확인

    if (!sessionUser || Object.keys(sessionUser).length === 0) {
        // 세션 값이 없거나 빈 객체일 경우 로그인 페이지로 리다이렉트
        return <Navigate to="/system" replace />;
    }

    // 세션 값이 있으면 자식 컴포넌트를 렌더링
    return children;
};

export default PrivateRoute;